import { MicroSite } from '@/api/useGetMicroSiteApi'

const apiEnv = process.env.NEXT_PUBLIC_API_ENV || ''

/**
 * Returns the base URL depending on environment.
 */
export function getBaseUrl(): string {
  const hostedEnvs = ['production', 'staging', 'dev1', 'dev2']

  // If in the browser and not development, use kettle-integration staging URL
  if (typeof window !== 'undefined' && hostedEnvs.includes(apiEnv)) {
    const { host, protocol } = window.location

    const domain = host.startsWith('www') ? host : `www.${host}`

    return `${protocol}//${domain}`
  }

  // Otherwise, default to localhost
  return process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:3000'
}

/**
 * Returns the URL for the v5 API endpoint.
 *
 * TODO: Handle CORS fix more elegantly
 * We now have  front end and backend on the same server so we no longer neeed
 * the _api proxy
 * @param {string} path - The specific API path to append.
 *
 * @returns {string} - The full URL for the v5 API endpoint.
 */
export function getV5ApiUrl(path: string): string {
  return `${getBaseUrl()}/api/v5${path}`
}

/**
 * Returns the URL for the v6 API endpoint.
 *
 * TODO: Handle CORS fix more elegantly
 *
 *
 * @param {string} path - The specific API path to append.
 *
 * @returns {string} - The full URL for the v6 API endpoint.
 */
export function getV6ApiUrl(path: string): string {
  return `${getBaseUrl()}/api/v6${path}`
}

/**
 * Returns the URL for the v3 API endpoint.
 *
 * TODO: Handle CORS fix more elegantly
 *
 *
 * @param {string} path - The specific API path to append.
 *
 * @returns {string} - The full URL for the v3 API endpoint.
 */
export function getV3ApiUrl(path: string): string {
  return `${getBaseUrl()}/api/v3${path}`
}

/**
 * Determines the default GraphQL endpoint based on the environment.
 *
 * @returns {string} - The default GraphQL API endpoint.
 */
export function getDefaultEndpoint(): string {
  return `${getBaseUrl()}/graphql`
}

/**
 * Returns the Lambda endpoint for the GraphQL API.
 *
 * @returns {string} - The Lambda endpoint for the GraphQL API.
 */
export function getLambdaEndpoint(brand: string): string {
  if (process.env.NEXT_PUBLIC_API_ENV === 'production') {
    return `${getBaseUrl()}/api/v6/graphql`
  }
  // v6/graphql is the shared AppSync API (autocomplete/countries/places), not
  // a branch-isolated backend. Only the classic staging distros route it —
  // branch test-server distros have no /api/v6/graphql behavior — so non-prod
  // must stay pinned to classic staging rather than the serving host.
  return `https://staging.${brand}.com/api/v6/graphql`
}

export function getMicroSiteLogoUrl(microSite: MicroSite): string {
  const env = process.env.NEXT_PUBLIC_API_ENV || 'development'

  const logo = microSite.logo

  if (env === 'development') {
    return `${getBaseUrl()}/${logo}`
  }

  return logo
}
